<template>
<!-- eslint-disable -->
  <div class="q-detail-wrap" id="q-detail-wrap">
    <header class="banner">
      <p style="height:32px" v-if="islogoLenovo"></p>
      <p v-else><img src="~@/assets/img/report_logo.png" alt=""></p>
      <h2>Diagnosis Report</h2>
      <h3>题目详情</h3>
    </header>
    <section class="content">
      <div class="qs-content content-cont">
        <div class="my-true">
          <h2>我的正确率<span>{{parseInt(my_accuracy*100)}}%</span></h2>
          <p>总作答 {{is_all_num}}题 ｜ 答对题数  {{is_right_num}}题 ｜ 答错题数  {{is_error_num}}题</p>
          <div class="every-see">
            <span>每页查看</span>
            <el-select v-model="per_page" placeholder="请选择">
              <el-option
                @click.native="getData(1)"
                v-for="(item, index) in sel_qs_num"
                :key="index"
                :value="item">
              </el-option>
            </el-select>
            <p id="find-error" @click="getErrorQus">
              <span class="xx-round"><i v-show="is_right" class="round-check"></i></span>
              <span class="xx-round-test">只显示错题</span>
            </p>
          </div>
        </div>
        <div id="allSubject" class="all-subject" v-for="(item, index) in q_list" :key="index">
          <div v-if="item.question_type == 1 && isShowData" class="select-question small-subject" :id="item.question_id">
            <h2>{{current_page*per_page-per_page+index+1}}、单选题
                <!-- 复制题目ID -->
                <div class="copy-wrap">
                  <span class="copy-small" slot="reference">ID:{{item.question_id}}</span>
                  <span class="copy" @click="copyId(item.question_id)">复制</span>
                </div>
            </h2>
            <div class="answer-time">
              <ul>
                <li>答题时间：<span>{{item.do_question_time}}</span><span v-if="item.defeat">（击败了{{Math.round(item.defeat*100)}}%的学生）</span></li>
                <li>本题平均正确率：<span>{{Math.round(item.accuracy*100)}}%</span></li>
                <li>本题难度：<span>{{item.difficulty}}</span></li>
              </ul>
            </div>
            <div v-if="course_type=='V5'">
              <div class="answer-title" v-if="isShowData" v-katexHtml="htmlDeCode(item.content.content)"></div>
              <div v-if="item.content.img_data && item.content.img_data.length">
                <img v-for="(img,index) in item.content.img_data" :key="index" v-if="img.source" :src="img.source"/>
              </div>
            </div>
            <div v-else>
              <div class="answer-title" v-if="isShowData" v-katexHtml="htmlDeCode(item.content)"></div>
            </div>
            <input type="hidden" value="q_id" name="question_id">
            <div class="answer-content" v-if="course_type!='V5'">
              <!--<p class="select-title">下列选文加点实词解释正确的一项（    ）</p>-->
              <div class="right-ans-wrap" v-for="(list, index) in item.options"
                   :key="index"
                   :data="list.key">
                <span class="right-ans-key" v-katex="htmlDeCode(list.key)+'、'"></span>
                <p class="rit-answer" v-if="isShowData" v-katexHtml="list.answer"></p>
              </div>
            </div>
            <div class="answer-content" v-else>
              <div class="right-ans-wrap" v-for="(list, index) in item.options"
                    :key="index"
                    :data="list.key">
                <span class="right-ans-key" v-katex="htmlDeCode(list.key)+'、'"></span>
                <p class="rit-answer" v-if="isShowData" v-katexHtml="list.content"></p>
                <p class="choose-img" v-if="list.img_data && list.img_data.length">
                  <img v-for="(img,index) in list.img_data" v-if="list.source!=''" :key="index" :src="img.source">
                </p>
              </div>
            </div>
            <div class="true-answer">
              <p>参考答案</p>
              <p v-if="subject_id == 3 || subject_id == 1" v-html="item.answer"></p>
              <p v-else v-katexHtml="htmlDeCode(item.answer.replace(/<\/?(p|div|br)[^>]*>/g, '').replace(/</g, '< ').replace(/>/g, ' >'))"></p>
            </div>
            <div class="error-answer">
              <p>我的答案</p>
              <p class="answer-error" v-if="item.user_answer == ''">
                <span>未作答</span>
                <i class="yxiconfont el-icon-close"></i>
              </p>
              <p v-else-if="!item.is_right" class="answer-error">{{item.user_answer}}
                <i class="yxiconfont el-icon-close"></i>
              </p>
              <p v-else class="answer-true">{{item.user_answer}}
                <i class="yxiconfont el-icon-check"></i>
              </p>
            </div>
            <div v-if="course_type=='V5'" class="answer-ansisly">
              <h3>题目解析</h3>
              <div class="dl-block">
                <div v-for="(li, index) in item.analyze" :key="index">解析:
                  <p v-if="isShowData && li.title" v-katexHtml="htmlDeCode(li.title)"></p>
                  <div v-for="(cont, index) in li" v-if="isShowData && cont.content"
                       :key="index">
                     <div v-katexHtml="cont.content.replace(/\$\$/g, '$ $')"></div>
                    <div v-if="cont.img_data && cont.img_data.length">
                      <img v-for="(img,k) in cont.img_data" v-if="img.source" :key="k" :src="img.source"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="answer-ansisly">
              <h3>题目解析</h3>
              <div v-if="subject_id == 3 || subject_id == 1">
                <div class="dl-block yw-jx" v-if="isShowData && item.analyze.analyze_text">解析:
                  <p  v-katexHtml="item.analyze.analyze_text"></p>
                </div>
              </div>
              <div class="dl-block" v-else>
                <div v-for="(li, index) in item.analyze" :key="index">解析:
                  <p v-if="isShowData && li.title" v-katexHtml="htmlDeCode(li.title)"></p>
                  <div v-if="isShowData" v-for="(cont, index) in li.content"
                     :key="index"
                     v-katexHtml="htmlDeCode(cont.content)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="item.question_type == 2 && isShowData" class="select-question small-subject" :id="item.question_id">
            <h2>{{current_page*per_page-per_page+index+1}}、填空题
              <!-- 复制题目ID -->
              <div class="copy-wrap">
                <span class="copy-small" slot="reference">ID:{{item.question_id}}</span>
                <span class="copy" @click="copyId(item.question_id)">复制</span>
              </div>
            </h2>
            <div class="answer-time">
              <ul>
                <li>答题时间：<span>{{item.do_question_time}}</span><span v-if="item.defeat">（击败了{{Math.round(item.defeat*100)}}%的学生）</span></li>
                <li>本题平均正确率：<span>{{Math.round(item.accuracy*100)}}%</span></li>
                <li>本题难度：<span>{{item.difficulty}}</span></li>
              </ul>
            </div>
            <!--<div class="answer-title" v-if="isShowData" v-ubbToHtml="htmlDeCode(item.content)">-->
            <div v-if="course_type=='V5'">
              <div class="answer-title" v-if="isShowData" v-katexHtml="htmlDeCode(item.content.content)"></div>
              <div v-if="item.content.img_data && item.content.img_data.length">
                <img v-for="(img,index) in item.content.img_data" :key="index" :src="img.source"/>
              </div>
            </div>
            <div v-else>
              <div class="answer-title" v-if="isShowData" v-katexHtml="item.content">
            </div>

            </div>
            <input type="hidden" value="q_id" name="question_id">
            <div class="true-answer">
              <p>参考答案</p>
              <!-- \\(8+4\\sqrt{3}<ab\\);<p>\\(\\frac{1}{2}\\le&nbsp;ab>cs\\)<\/p>;<p>\\(\\pi\\)\\(<\\)abc<br \/><\/p> -->
              <p v-if="subject_id == 3 || subject_id == 1" v-html="item.answer"></p>
              <p v-else v-katexHtml="htmlDeCode(item.answer.replace(/<\/?(p|div|br)[^>]*>/g, '').replace(/</g, '< ').replace(/>/g, ' >'))"></p>
            </div>
            <div class="error-answer">
              <p>我的答案</p>
              <p class="answer-error" v-if="item.user_answer==''">
                <span>未作答</span>
                <i class="yxiconfont el-icon-close"></i>
              </p>
              <!-- <p v-else class="answer-true" v-for="(a,index) in htmlCodeTwo(item.user_answer)" :key="index">-->
              <!--<p v-else class="answer-true" v-html="'\\(\\\approx\\\approx\\)'">-->
              <div class="fill-user-wrap answer-error" v-else-if="!item.is_right">
                <p v-if="subject_id == 3 || subject_id == 1" v-html='item.user_answer'></p>
                <p v-else v-katex="item.user_answer.replace(/<\/?(p|div|br)[^>]*>/g, '').replace(/</g, '< ').replace(/>/g, ' >')"></p>
                <i class="icon yxiconfont el-icon-close"></i>
              </div>
              <div v-else class="answer-true fill-user-wrap">
                <p v-if="subject_id == 3 || subject_id == 1" v-html="item.user_answer"></p>
                <p v-else v-katex="htmlDeCode(item.user_answer)"></p>
                <i class="icon yxiconfont el-icon-check"></i>
              </div>
            </div>
            <div v-if="course_type=='V5'" class="answer-ansisly">
              <h3>题目解析</h3>
              <div class="dl-block">
                <div v-for="(li, index) in item.analyze" :key="index">解析:
                  <p v-if="isShowData && li.title" v-katexHtml="htmlDeCode(li.title)"></p>
                  <div v-for="(cont, index) in li" v-if="isShowData && cont.content"
                       :key="index">
                    <div  v-katexHtml="htmlDeCode(cont.content)"></div>
                    <div v-if="cont.img_data && cont.img_data.length">
                      <img v-for="(img,k) in cont.img_data" v-if="img.source" :key="k" :src="img.source"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="answer-ansisly">
              <h3>题目解析</h3>
              <div v-if="subject_id == 3 || subject_id == 1">
                <div class="dl-block yw-jx" v-if="isShowData && item.analyze.analyze_text">解析:
                  <p v-katexHtml="item.analyze.analyze_text"></p>
                </div>
              </div>
              <div class="dl-block" v-else>解析:
                <div v-if="isShowData" v-for="(li, index) in item.analyze" :key="index">
                  <p v-if="li.title" v-katexHtml="htmlDeCode(li.title)"></p>
                  <div v-for="(cont, index) in li.content"
                       :key="index"
                       v-katexHtml="htmlDeCode(cont.content)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--<footer class="fc-content nav-page-list page-fy">-->
      <!--<ul>-->
        <!--<li @click="prevPage">-->
          <!--<a><i class="el-icon-caret-left"></i></a>-->
        <!--</li>-->
        <!--<li v-for="(item, index) in total_page"-->
            <!--:class = "[current_page == parseInt(index+1) ? 'check' : 'uncheck']"-->
            <!--:key="index" :rel="index" @click="getPageQus">-->
          <!--<a>{{index+1}}</a>-->
        <!--</li>-->
        <!--<li @click="nextPage">-->
          <!--<a><i class="el-icon-caret-right"></i></a>-->
        <!--</li>-->
        <!--<li class="no-bor">-->
          <!--<span>跳转到</span>-->
          <!--<input type="text" v-model="jump_page"/>-->
        <!--</li>-->
        <!--<li id="submit_page" @click="jumpPage">-->
          <!--<i class="el-icon-arrow-right"></i>-->
        <!--</li>-->
      <!--</ul>-->
    <!--</footer>-->
    <footer class="fc-content nav-page-list page-fy">
      <div class="block">
        <el-pagination
          v-if="is_all_num"
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="prev, pager, next, jumper"
          :total="get_err_qs?is_error_num:is_all_num">
        </el-pagination>
      </div>
    </footer>
    <div class="mark" id="mark" :style="{'height' : bHeight}"
     :class="[{'mark-lenovo':islogoLenovo}]"></div>
    <go-top />
  </div>
</template>

<script>
/* eslint-disable */
import {
  htmlDecodeByRegExp,
  isArray,
  isString,
} from '@/pages/dl-web/utils/index';
import api from '@/pages/dl-web/api/api';
import { getSign } from '@/pages/dl-web/utils/verify';
import goTop from './components/toTop';

export default {
  name: 'questionDetail',
  data() {
    return {
      tsid: '',
      is_right_num: 0, // 对题数
      is_error_num: 0, // 错题数
      is_all_num: 0, // 总作答数
      total_page: 0, // 总页数
      get_err_qs: false,
      my_accuracy: null, // 我的正答率
      sel_qs_num: [
        '5',
        '10',
        '20',
      ],
      q_id: '', // 题目id
      q_list: [], // 题目列表
      question_type: 1, // 题目类型 1: 单选题; 2: 填空题
      answer_title: '', // 题目标题
      answer_time: '', // 作答时间
      beat_num: '', // 击败学生率
      right_prob: '', // 平均正确率
      q_difficulty: '', // 本题难度
      qOptions: [], // 选择题选项
      qAnswer: null, // 题目答案
      refer_answer: null, // 参考答案
      // user_answer: null , //我的答案
      is_right: 0, // 只显示错题 0所有  1 只显示错题
      per_page: 5, // 每页显示多少条题
      current_page: 1, // 当前第几页
      jump_page: null, // 跳转到第几页
      subject_id: null, // 学科id
      bHeight: '',
      user_answer: [], // 用户回答
      isShowData: false,
      loading: null,
      course_type: '', // 是否是v5
    };
  },
  components: {
    goTop,
  },
  created() {
    this.tsid = this.$route.query.tsid;
    this.getData();
  },
  computed: {
    //判断是否是特殊校区
    islogoLenovo(){
      let id = this.$route.query.schoolId || localStorage.getItem('school_id') 
      || '';
      return id ==='20023' || id === '20022' || id === '20043' || id === '2217';
    }
  },
  watch: {
    q_list() {
      this.$nextTick(() => {
        this.bHeight = `${document.getElementById('q-detail-wrap').offsetHeight - 50}px`;
      });
    },
  },
  mounted() {
    // this.getData()
  },
  methods: {
    async getData(pageNmu) {
      this.isShowData = false;
      this.loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        // target: document.querySelector('#allSubject')
      });
      if (pageNmu) {
        this.current_page = 1;
      }
      const that = this;
      const parms = {
        tsid: this.tsid,
        is_right: this.is_right,
        per_page: this.per_page,
        current_page: this.current_page,
        time_stamp: (new Date()).getTime(),
      };
      parms.sign = getSign(parms);
      const res = await api.getQuestiondetail(parms);
      if (res) {
        this.loading.close();
        if (res.code == 0) {
          window.scrollTo(0, 0);
          const resData = res.data;
          this.isShowData = true;
          this.my_accuracy = resData.data.accuracy;
          this.is_all_num = resData.data.question_num;
          this.is_right_num = resData.data.right_num;
          this.is_error_num = resData.data.error_num;
          this.total_page = resData.total_page;
          this.subject_id = resData.data.subject_id || '';
          this.q_list = resData.data.question_info || [];
          this.course_type = resData.data.course_type || '';
          this.q_list.forEach((v, i) => {
            // that.q_list[i].user_answer = that.htmlCodeTwo(v.user_answer)
            // console.log(v)
            // that.user_answer = JSON.parse(v.user_answer)
            if (v.kda) {
              kData.x_kda_data.push(v.kda);
              kData.y_kda_data.push({ value: v.kda_count });
            }
          });
        } else {
          this.loading.close();
          this.$toast(res.msg);
        }
      } else {
        this.loading.close();
        this.$toast('网络错误，请刷新');
      }
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData();
    },
    async getErrorQus() {
      this.is_right = !this.is_right == true ? 1 : 0;
      this.current_page = 1;
      this.get_err_qs = !this.is_right != true;
      this.getData();
      console.log(this.get_err_qs);
    },
    getPageQus(event) {
      const el = event.currentTarget;
      this.current_page = parseInt(el.getAttribute('rel')) + 1;
      this.getData();
    },
    prevPage(event) {
      if (this.current_page > 1) {
        this.current_page -= 1;
        this.getData();
      }
    },
    nextPage(event) {
      if (this.current_page < this.total_page) {
        this.current_page += 1;
        this.getData();
      }
    },
    jumpPage(event) {
      if (this.jump_page != '') {
        this.current_page = this.jump_page;
        if (this.current_page > this.total_page) {
          this.$toast(`页数不能大于${this.total_page}`);
          this.jump_page = '';
          return;
        }
        this.getData();
      }
    },
    // 复制ID
    copyId(id) {
      const input = document.createElement('input');
      input.value = id;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length), document.execCommand('Copy');
      document.body.removeChild(input);
      this.$toast('复制成功');
    },
    // 转换html字符串
    htmlDeCode(str) {
      const res = htmlDecodeByRegExp(str);
      return res;
    },
    htmlCodeTwo(str) {
      if (str.indexOf('[') != -1) {
        const html = []; let reslut = ''; const oneStr = [];
        const value2 = str.replace(/\\\(/g, '');
        const value3 = value2.replace(/\\\)/g, '');
        let value4 = value3.replace(/\[/, '');
        value4 = value4.substring(0, value4.lastIndexOf(']'));
        if (value4.indexOf(',') != -1) {
          value4 = value4.split(',');
        } else {
          oneStr[0] = value4.replace(/\"/g, '');
          value4 = oneStr;
        }
        value4.forEach((item, i) => {
          if (item != '') {
            let str = item.replace(/\\/, '');
            str = `\\(${str}\\)`;
            html[i] = str.replace(/\"/g, '');
          }
          if (i == value4.length - 1) {
            reslut += html[i];
          } else {
            reslut += `${html[i]};`;
          }
        });
        return reslut;
      }
      return str;
    },
  },
};
</script>

<style scoped >
  .mark{
    width: 100%;
  }
  .q-detail-wrap .banner{
    width: 100%;
    height: 320px;
    background: url('~@/assets/img/bg_subject.png') no-repeat center;
    background-size: cover;
    width: 1200px;
    max-width: 100%;
    padding-top: 26px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .banner p{
    width: 232px;
    height: 32px;
    margin-left: 32px;
  }
  .banner p img{
    width: 100%;
    height: 100%;
  }
  .banner h2{
    font-family:Arial-BoldItalicMT;
    font-size:48px;
    color:#ffffff;
    text-align: center;
    margin-top: 56px;
  }
  .banner h3{
    font-size:24px;
    color:#ffffff;
    letter-spacing:10px;
    line-height:24px;
    text-align: center;
    margin-top: 20px;
  }
  /*-------------------------content----------------------*/
  .content{
    width: 100%;
    background: #fcfcfc;
  }
  .content .content-cont{
    background:#ffffff;
    border:1px solid #eaeaea;
    box-shadow:0 0 4px 0 rgba(0,0,0,0.04);
    border-radius:2px;
    width:1198px;
    margin: 35px auto;
    max-width: 100%;
  }
  .content .content-cont .my-true{
    padding: 21px 0 32px;
    border-bottom: 1px solid #eaeaea;
  }
  .content .content-cont .my-true h2{
    font-size:32px;
    color:#333333;
    font-weight: normal;
    margin-left: 40px;
  }
  .content .content-cont .my-true h2 span{
    margin-left: 24px;
    font-weight: bold;
  }
  .content .content-cont .my-true p{
    font-size:14px;
    color:#666666;
    line-height: 24px;
    margin-top: 16px;
    margin-left: 40px;
  }
  .content .content-cont .my-true .every-see{
    margin-left: 40px;
    margin-top: 12px;
    position: relative;
    z-index: 1003;
  }
  .content .content-cont .my-true .every-see span{
    font-size: 12px;
    color:#333;
    margin-right: 8px;
  }
  .content .content-cont .my-true .every-see select{
    background:#ffffff;
    border:1px solid #eaeaea;
    border-radius:4px;
    width:94px;
    height:30px;
    font-size:14px;
    color:#333333;
  }
  .content .content-cont .my-true .every-see #find-error{
    display: inline-block;
  }
  .content .content-cont .my-true .every-see #find-error .xx-round{
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    border: 1px #ccc solid;
    position: relative;
  }
  .content .content-cont .my-true .every-see #find-error .xx-round .round-check{
    width: 8px;
    height: 8px;
    background: #000;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    left: 3px;
    top:3px;
  }
  .content .content-cont .all-subject{
    width: 840px;
    padding-left: 40px;
    max-width: 100%;
  }
  .content .content-cont .all-subject .small-subject{
    position: relative;
    border-bottom: 1px solid #eaeaea;
    padding: 31px 0 40px 0;
  }
  .content .content-cont .all-subject .small-subject:last-child{
    border-bottom: none;
  }
  .content .content-cont .all-subject h2{
    font-size:24px;
    color:#333333;
    line-height: 32px;
  }
  .content .content-cont .all-subject .answer-time{
    height: 32px;
    background: rgba(238,238,238,.5);
    padding: 0 16px;
    margin-top: 20px;
  }
  .content .content-cont .all-subject .answer-time ul li{
    display: inline-block;
    line-height: 32px;
    color:#666;
  }
  .content .content-cont .all-subject .answer-time ul li span{
    color:#000;
  }
  .content .content-cont .all-subject .answer-time ul li:nth-of-type(2){
    margin-left: 24px;
  }
  .content .content-cont .all-subject .answer-time ul li:nth-of-type(3){
    float: right;
  }
  .content .content-cont .all-subject .answer-title{
    margin-top: 24px;
    font-size:16px;
    color:#333333;
    line-height: 28px;
  }
  .content .content-cont .all-subject .answer-content{
    margin-top: 24px;
  }
  .content .content-cont .all-subject .answer-content p{
    font-size:16px;
    color:#333333;
    line-height: 28px;
    display: inline-block;
  }
  .content .content-cont .all-subject .answer-content p.choose-img{
    display: block;
  }
  .content .content-cont .all-subject .answer-content div.checkbox{
    margin-top: 10px;
  }
  .content .content-cont .all-subject .answer-content div.checkbox:nth-of-type(1){
    margin-top: 16px;
  }
  .content .content-cont .all-subject .answer-content div.checkbox label{
    font-size:16px;
    color:#333333;
    line-height: 28px;
  }
  .content .content-cont .all-subject .answer-content div.checkbox label p{
    display:inline-block;
  }
  .content .content-cont .all-subject .answer-content div.checkbox label input{
    display: none;
  }
  .content .content-cont .all-subject .true-answer{
    margin-top: 32px;
  }
  .content .content-cont .all-subject .true-answer p{
    font-size:16px;
    color:#999999;
    line-height: 28px;
  }
  .content .content-cont .all-subject .true-answer p:nth-of-type(2){
    color:#000;
  }
  .content .content-cont .all-subject .error-answer{
    margin-top: 16px;
  }
  .content .content-cont .all-subject .error-answer p{
    font-size:16px;
    color:#999999;
    line-height: 28px;
  }
  .content .content-cont .all-subject .error-answer .answer-true,
  .content .content-cont .all-subject .error-answer .answer-true p{
    color:#37d279;
  }
  .content .content-cont .all-subject .error-answer .answer-error,
  .content .content-cont .all-subject .error-answer .answer-error p{
    color:#ff4081;
  }
  .content .content-cont .all-subject .error-answer p.answer-true i.check-error{
    display: none;
  }
  .content .content-cont .all-subject .error-answer p.answer-error i.check-true{
    display: none;
  }
  .content .content-cont .all-subject .answer-ansisly{
    margin-top: 32px;
  }
  .content .content-cont .all-subject .answer-ansisly h3{
    font-size:24px;
    color:#333333;
    line-height: 32px;
  }
  .content .content-cont .all-subject .answer-ansisly div.dl-block{
    background:#ffffff;
    box-shadow:0 0 20px 0 rgba(0,0,0,0.05);
    width:800px;
    max-width: 100%;
    padding: 24px;
    margin-top: 24px;
    font-size:16px;
    color:#333333;
    line-height: 28px;
  }
  .content .content-cont .all-subject .voice{
    cursor: pointer;
    display: none;
  }
  .content .content-cont .all-subject .voicej{
    width: 40px;
    height: 40px;
    display: inline-block;
    background: url('~@/assets/img/speaker3.png') no-repeat;
    background-size: contain;
    margin: 10px 60px;
  }
  .content .content-cont .all-subject .voiced{
    width: 40px;
    height: 40px;
    display: inline-block;
    background: url('~@/assets/img/volume.gif') no-repeat;
    background-size: contain;
    margin: 10px 60px;
  }
  .content .content-cont .all-subject .voices{
    cursor: pointer;
    display: none;
  }
  .content .content-cont .all-subject .voicej{
    width: 40px;
    height: 40px;
    display: inline-block;
    background: url('~@/assets/img/speaker3.png') no-repeat;
    background-size: contain;
    margin: 10px 60px;
  }
  .content .content-cont .all-subject .voiced{
    width: 40px;
    height: 40px;
    display: inline-block;
    background: url('~@/assets/img/volume.gif') no-repeat;
    background-size: contain;
    margin: 10px 60px;
  }
  .page-fy{
    position: relative;
    z-index: 1000000;
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
  }
  .nav-page-list>ul {
    min-height: 40px;
    margin: 24px auto;
    display: flex;
    position: absolute;
  }
  .nav-page-list>ul>li{
    cursor: pointer;
  }
  /*.nav-page-list>ul>li,*/
  /*.nav-page-list>ul>li.no-bor input[type=text],*/
  .el-pagination button, .el-pager li{
    background: #ffffff;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    margin: 0 3px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    border: 1px solid #cccccc;
    color: #ccc;
    outline: none;
  }
  .nav-page-list>ul>li.no-bor{
    width: auto;
    border: none;
    cursor: auto;
  }
  .nav-page-list>ul>li.check{
    width: 40px;
    height: 40px;
    background: #397CF6;;
    border-radius: 20px;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 40px;
    text-align: center;
  }
  .fill-user-wrap{
    display: flex;
  }
  .fill-user-wrap .icon{
    width: 20px;
    line-height: 24px;
    margin-left: 10px;
    flex: 0 0 auto;
  }
  .active{
    background: none;
  }
  .el-dialog{
    width: 60%!important;
  }
  i.col-line {
  display: inline-block;
  width: 1px;
  height: 15px;
  margin: 0 2px;
  vertical-align: middle;
  background: rgba(238, 238, 238, 1);
}
.copy-wrap{
  position: relative;
  display: inline-block;
  padding-left: 10px;
  z-index: 9999;
  color: #666;
  font-size: 16px;
}
.copy {
  height: 17px;
  padding-left: 10px;
  font-size: 14px;
  line-height: 17px;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
  text-decoration: underline;
}
.copy-small {
  display: inline-block;
}
@media screen and (max-width: 1440px) {
  .el-dialog{
    width: 55%!important;
  }
}
@media screen and (min-width: 1600px) {
  .el-dialog{
    width: 50%!important;
  }
}
.mark-lenovo{
  background: none !important;
}
#mark{
  position: absolute;
  top: 0;
  left: 0;
  background: url('~@/assets/img/mark@2x.png');
  background-repeat: repeat-y;
  background-size: contain;
  z-index: 1000;
}
.MJXc-display{
  text-align: left!important;
}
</style>
